import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { getAuth, signInWithEmailAndPassword } from 'firebase/auth';
import firebaseApp from 'config/firebase';
import Header from 'components/Header';
import TextInput from 'components/TextInput';
import Button from 'components/Button';
import Popup from 'components/Popup';
import useOutsideClickHandler from 'hooks/useOutsideClickHandler';
import './index.css';

function SignIn() {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');

    const auth = getAuth(firebaseApp);
    const errorRef = useOutsideClickHandler(() => setError(''));

    const handleSignIn = (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();

        signInWithEmailAndPassword(auth, email, password)
            .catch(error => {
                console.log(error.message);
                setError(error.message);
            });
    }

    if (error) {
        return (
            <Popup
                title='Signin failed'
                primaryButtonText='Close'
                primaryButtonOnClick={() => setError('')}
                innerRef={errorRef}
            >
                {error}
            </Popup>
        );
    }

    return (
        <>
            <Helmet>
                <title>
                    Sign In - Test Center Admin
                </title>
            </Helmet>
            <Header title='Sign In' />
            <form className='signIn' onSubmit={handleSignIn}>
                <TextInput
                    className='signIn__input'
                    label='email'
                    placeholder='enter email'
                    type='email'
                    value={email}
                    onChange={event => setEmail(event.target.value)}
                    required
                />
                <TextInput
                    className='signIn__input'
                    label='password'
                    placeholder='enter password'
                    type='password'
                    value={password}
                    onChange={event => setPassword(event.target.value)}
                    required
                />
                <Button
                    className='signIn__button'
                    type='submit'
                >
                    Sign In
                </Button>
            </form>
            <p className='signIn__reset'>
                Forgot password? <Link to='/password-reset'>Click here to reset</Link>
            </p>
        </>
    );
}

export default SignIn;